import { useSearchParams } from "react-router-dom";
import { BookOpen, Users, ShieldCheck, AlertTriangle, Sparkles, GraduationCap, Crown } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function DashboardHome() {
  const { user } = useAuth();
  const [params] = useSearchParams();
  const denied = params.get("denied") === "1";

  const cards = [
    {
      title: "Area Allievi",
      desc: "Questionario teorico per la promozione a Vice Sceriffo.",
      icon: GraduationCap,
      to: "/dashboard/allievi",
      enabled: user?.is_student,
    },
    {
      title: "Area Agenti",
      desc: "Codice Penale, Codici Radio e Manuale dell'Operatore.",
      icon: BookOpen,
      to: "/dashboard/agenti",
      enabled: user?.perm_agents,
    },
    {
      title: "Risorse Umane",
      desc: "Gestione delle candidature: Accetta, Rifiuta, Lascia in Sospeso.",
      icon: Users,
      to: "/dashboard/hr",
      enabled: user?.perm_hr,
    },
    {
      title: "Area Comando",
      desc: "Eventi e creazione di news ufficiali.",
      icon: ShieldCheck,
      to: "/dashboard/comando",
      enabled: user?.is_command,
    },
    {
      title: "Area Esecutiva",
      desc: "Utenti, esami promozione, backup e amministrazione completa.",
      icon: Crown,
      to: "/dashboard/esecutiva",
      enabled: user?.is_executive,
    },
  ].filter((c) => c.enabled || ["Area Agenti", "Risorse Umane", "Area Comando", "Area Esecutiva"].includes(c.title));

  return (
    <div className="space-y-8" data-testid="dashboard-home">
      {denied && (
        <div data-testid="dashboard-denied" className="flex items-start gap-3 p-4 bg-amber-50 border border-amber-200 rounded-xl text-sm text-amber-800">
          <AlertTriangle className="h-5 w-5 mt-0.5" />
          <div>
            <div className="font-bold">Accesso negato</div>
            <div>Non hai i permessi necessari per visualizzare quella sezione.</div>
          </div>
        </div>
      )}

      <div>
        <div className="uppercase-label text-sheriff-gold mb-2 flex items-center gap-2">
          <Sparkles className="h-4 w-4" /> Pannello Operatore
        </div>
        <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tighter text-[#F5E6B8]">
          Aree disponibili in base ai tuoi permessi
        </h1>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {cards.map((c) => (
          <a
            key={c.to}
            href={c.enabled ? c.to : undefined}
            data-testid={`card-${c.title.toLowerCase().replace(/\s/g, "-")}`}
            className={`block p-6 bg-[#143830] border ${c.enabled ? "border-sheriff-gold/25 hover:border-sheriff-gold" : "border-sheriff-gold/25 opacity-50 cursor-not-allowed"} rounded-xl transition-colors duration-150`}
          >
            <div className={`h-12 w-12 flex items-center justify-center rounded-xl ${c.enabled ? "bg-sheriff-green text-white" : "bg-slate-200 text-[#B8A269]"} mb-4`}>
              <c.icon className="h-6 w-6" />
            </div>
            <h3 className="font-heading font-bold text-xl text-[#F5E6B8] mb-2">{c.title}</h3>
            <p className="text-sm text-[#D4C480] leading-relaxed">{c.desc}</p>
            <div className={`mt-4 uppercase-label ${c.enabled ? "text-sheriff-gold" : "text-[#8B7B49]"}`}>
              {c.enabled ? "Accedi →" : "Permesso non attivo"}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
